module.exports = __webpack_public_path__ + "media/ethereal_flame.3629086d.webm";